export default {
  currentParkingReportingData: {
    carFrontPhotoPreviewUrl: null,
    carPlate: "",
    currentPosition: null,
  },
  loading: null,
  parkingsData: [],
}
